/**
 * Server-authoritative SIWE session (Macro #29 Stage 3).
 * The connected wagmi wallet is NEVER authority — the session wallet comes from
 * GET /api/v1/auth/me. Fail-closed: any error → not authenticated.
 */
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export interface SessionState {
  wallet: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export function useSession(): SessionState {
  const q = useQuery({
    queryKey: ["mkt", "session"],
    queryFn: async ({ signal }) => {
      void signal;
      const me = await api.me();
      return me.wallet.toLowerCase();
    },
    retry: false,
    staleTime: 15_000,
  });
  return {
    wallet: q.data ?? null,
    isAuthenticated: !!q.data,
    isLoading: q.isLoading,
  };
}
